import { ApolloClient } from '@apollo/client';
import IDimensions from '../model/IDimensions';
import cache from './cache';
import { gql } from '@apollo/client/core';

const typeDefs = gql`
  type FeatureSection {
    id: String
    value: Boolean
  }

  extend type CatalogResult {
    financeFormInput: FinanceFormInput
  }

  extend type CustomizedCarConfiguration {
    financeFormInput: FinanceFormInput
    selectedActiveSectionName: String
    selectedCurrency: String
    selectedSections: [FeatureSection]
    selectedFeaturesId: [String]
  }

  extend type TrimLevelVariants {
    financeFormInput: FinanceFormInput
    marketingCategories: [String]
  }
`;

const generateApolloClient = (dimensions: IDimensions) =>
  new ApolloClient({
    uri: process.env.GRAPHQL_SERVER_URL,
    cache,
    headers: {
      'X-Brand': dimensions.brand,
      'X-Language': dimensions.language,
      'X-Region': dimensions.region,
      'X-Country': dimensions.country,
    },
    typeDefs,
  });

export default generateApolloClient;
